import { notAvailable } from 'core/common/constants';
import { normalizeError } from 'core/common/errors';
import { ATTRS_ANALYTICS_FUNNEL_NAME, SpanName } from 'core/common/observability/entities';
import { AppThunk } from 'core/common/store';
import { getFunnelName } from 'core/funnel/store/getFunnelName';
import { getUserLocation } from 'core/user/store/selectors';
import { updateOrderId } from './paymentForm';

export const fetchOrderByOfferIdRequest =
  (offerId: string): AppThunk =>
  async (dispatch, getState, context) => {
    const {
      purchaseService,
      loggingService: logger,
      observabilitySystem,
      errorMonitoringService,
    } = context;
    // TODO check if we can remove it at all, after orderId saving has been moved to sessionStorage
    dispatch(updateOrderId(''));

    const userLocation = getUserLocation(getState());
    const funnelName = getFunnelName(getState());

    const spanAttributes = {
      [ATTRS_ANALYTICS_FUNNEL_NAME]: funnelName,
    };

    const span = observabilitySystem.startSpan(SpanName.CREATE_ORDER_FROM_EMAIL_UPSELLS);
    span.setAttributes(spanAttributes);
    span.addEvent('Pending');

    try {
      const data = await purchaseService.createOrderByOfferId(offerId);

      dispatch(updateOrderId(data.orderId));

      span.addEvent('Succeed');
      span.succeed();
    } catch (err) {
      const error = normalizeError(err);
      errorMonitoringService.captureError(error, {
        tags: {
          offer_id: offerId,
          get_params: location.search || notAvailable,
          error_message: error.message,
          error_reason: 'create_order_from_email_upsells',
          funnel_name: funnelName,
          ...userLocation,
        },
      });

      span.addEvent('Failed');
      span.fail(error);

      logger.error(error);
    }
  };
